import { getAuth, signOut } from "firebase/auth";

export const AUTH_SESSION_KEYS = [
  "Auth Token",
  "localId",
  "fullName",
  "isAdmin",
  "isReviewer",
];

export const clearStoredAuthSession = (storage = window.sessionStorage) => {
  AUTH_SESSION_KEYS.forEach((key) => storage.removeItem(key));
};

export const signOutAndClearSession = async (
  auth = getAuth(),
  storage = window.sessionStorage,
) => {
  await signOut(auth);
  clearStoredAuthSession(storage);
};
